import React, { Fragment } from "react";
import { useIntl } from 'react-intl';

import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TabsSection from "@components/TabsSection/tabsSection";
import TimelineFlexible from "./timelines/timelineFlexible";
import TimelineModerate from "./timelines/timelineModerate";
import TimelineNonRefundable from "./timelines/timelineNonRefundable";
import TimelineStrict from "./timelines/timelineStrict";

const heroImage = {
  url: `${process.env.CDN_URL}/images/policies-hero-image.jpg`,
  alt: 'Cancellation Policies Hero Image'
};

const CancellationPoliciesTemplate = ({ pageContext: { locale, activeTab, pageSlug } }) => {
  const intl = useIntl();

  const tabs = {
    flexible: {
      title: intl.formatMessage({ id: 'Flexible' }),
      components: [TimelineFlexible]
    },
    moderate: {
      title: intl.formatMessage({ id: 'Moderate' }),
      components: [TimelineModerate]
    },
    strict: {
      title: intl.formatMessage({ id: 'Strict' }),
      components: [TimelineStrict]
    },
    'non-refundable': {
      title: intl.formatMessage({ id: 'Non-refundable' }),
      components: [TimelineNonRefundable]
    },
  };

  return (
    <Fragment>
      <CustomSEO image={heroImage} title={tabs[activeTab].title} locale={locale} />
      <HeroSection
        heroHeading={intl.formatMessage({ id: 'Cancellation Policies' })}
        heroImage={heroImage}
        height={240}
        lazyload={false}
      />
      <UniplacesFullContainer>
          <TabsSection
            tabs={tabs}
            defaultTab={activeTab ? activeTab : Object.keys(tabs)[0]}
            locale={locale}
            pageSlug={pageSlug}
            hasTitle={false}
          />
          <Controls />
      </UniplacesFullContainer>
    </Fragment>
  );
};

const CustomSEO = ({
  image,
  title,
  locale,
}) => {
  const intl = useIntl();
  const metaTitle = `${intl.formatMessage({ id: 'Cancellation Policies' })} - ${title}`;
  const metaDescription = `${intl.formatMessage({ id: 'Flexible, Moderate, Strict, Non-refundable' })}`;

  return (
    <SEO
      title={metaTitle}
      description={metaDescription}
      imageUrl={image.url}
      lang={locale}
    />
  );
};

export default CancellationPoliciesTemplate;
